import { render, staticRenderFns } from "./LiveContentItem.vue?vue&type=template&id=e6dcecd4&scoped=true"
import script from "./LiveContentItem.vue?vue&type=script&lang=js"
export * from "./LiveContentItem.vue?vue&type=script&lang=js"
import style0 from "./LiveContentItem.vue?vue&type=style&index=0&id=e6dcecd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dcecd4",
  null
  
)

export default component.exports